import {
  Scissors,
  Droplets,
  Heart,
  Sparkles,
  Wind,
  Flower,
  ArrowUpRight,
} from "lucide-react";
import { BOOKING_URL, SERVICES } from "../lib/data";

const ICONS = {
  scissors: Scissors,
  droplets: Droplets,
  heart: Heart,
  sparkles: Sparkles,
  wind: Wind,
  flower: Flower,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-cream-alt overflow-hidden"
    >
      <div className="lilac-blur" style={{ top: "10%", left: "-300px", opacity: 0.6 }} />

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="max-w-3xl">
          <div className="eyebrow mb-5">— The Menu</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brown-dark leading-[1.05] tracking-tight">
            Thoughtful services, tailored to{" "}
            <em className="italic text-lilac-dark">every breed &amp; coat</em>.
          </h2>
          <p className="mt-6 text-lg text-text-secondary max-w-2xl">
            Every appointment is shaped around your pup — their breed, coat,
            comfort and personality. Full, transparent pricing for every size
            and service is shown on the booking page.
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Sparkles;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="service-card"
              >
                <div className="h-14 w-14 rounded-full bg-lilac-soft flex items-center justify-center mb-6">
                  <Icon size={22} className="text-lilac-dark" />
                </div>
                <h3 className="font-serif text-3xl text-brown-dark mb-3">
                  {s.title}
                </h3>
                <p className="text-text-secondary leading-relaxed mb-6">
                  {s.description}
                </p>
                <div className="flex items-center justify-between pt-5 border-t border-[#E6DEC3]/80">
                  <span className="eyebrow !text-brown-warm">
                    {s.duration}
                  </span>
                  <a
                    href={BOOKING_URL}
                    data-testid={`service-pricing-link-${i}`}
                    className="text-sm font-medium text-brown-dark underline-offset-4 underline decoration-lilac-dark hover:text-lilac-dark transition-colors"
                  >
                    Enquire →
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 bg-cream rounded-[2rem] border border-[#E6DEC3] p-8 md:p-10">
          <div>
            <div className="eyebrow mb-2">Ready when you are</div>
            <h3 className="font-serif text-2xl md:text-3xl text-brown-dark">
              Find a time that suits you &amp; your pup.
            </h3>
          </div>
          <a
            href={BOOKING_URL}
            data-testid="services-cta-button"
            className="btn-primary shrink-0"
          >
            Join Waitlist
            <ArrowUpRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
